<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <i class="fa-fw fas fa-clipboard text-blue-400"></i>
            </div>
        </template>
        <div class="flex mt-2">
            <div class="w-20">Name</div>
            <ui-input name="name" v-model="itemName" class="flex-grow"></ui-input>
        </div>
        <div class="flex mt-2" v-if="useGroups">
            <div class="w-20">Group</div>
            <ui-input name="name" v-model="itemGroup" class="flex-grow"></ui-input>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="form.busy" @click="form.submit(); close();"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";

export default {
    components: {PackageContactSearch, UiDataGrid, UiDataGridItem, UiInput},
    props: {
        type: String,
        name: String,
        useGroups: {
            type: Boolean,
            default: true
        },
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: ''
        },
        button: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            itemName: this.name,
            itemGroup: '',
            form: new Form({}, async (form) => {
                await this.handle(this.itemName, this.itemGroup, this)
            }),
        }
    },
    methods: {},
    mounted() {
    }
}
</script>
